import SendMessageButton from './SendMessageButton';
import { TextlineHistory } from './TextlineHistory';
import Loader from './Loader';
import { useStyles } from '../theme';

const styles = (theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1)
    }
  }
});

export const MessagesListing = ({
  gig,
  data,
  loading,
  error,
  textlineGroupUuid
}) => {
  const classes = useStyles(styles);
  if (loading) return <Loader />;
  if (error) return <div>{error.message}</div>;
  if (data) {
    return (
      <div className={classes.root}>
        {data.messageTemplates.map((template) => (
          <SendMessageButton
            key={template.id}
            messageTemplate={template}
            gigId={gig.id}
            textlineGroupUuid={textlineGroupUuid}
          />
        ))}
        <TextlineHistory gig={gig} />
      </div>
    );
  }
};
